/**
 * Improved Slugify function that handles special characters consistently with backend
 * This ensures URL generation matches the backend's slug generation exactly
 */

function slugify(text) {
  if (!text) return "";

  // Map of accented characters to their ASCII equivalents
  const charMap = {
    à: "a",
    á: "a",
    â: "a",
    ä: "a",
    æ: "ae",
    ã: "a",
    å: "a",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    ò: "o",
    ó: "o",
    ô: "o",
    ö: "o",
    õ: "o",
    ø: "o",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    ñ: "n",
    ç: "c",
    ß: "ss",
    ÿ: "y",
    // Uppercase equivalents
    À: "A",
    Á: "A",
    Â: "A",
    Ä: "A",
    Æ: "AE",
    Ã: "A",
    Å: "A",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Ö: "O",
    Õ: "O",
    Ø: "O",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    Ñ: "N",
    Ç: "C",
    Ÿ: "Y",
  };

  // Make a clean string with ASCII characters
  let cleanString = "";
  for (let i = 0; i < text.length; i++) {
    cleanString += charMap[text.charAt(i)] || text.charAt(i);
  }

  return cleanString
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/&/g, "-and-") // Replace & with 'and'
    .replace(/[^\w\-]+/g, "") // Remove all non-word characters except hyphens
    .replace(/:/g, "-") // Replace : with -
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
}

export default slugify;
